import React, { SyntheticEvent } from 'react';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import moment from 'moment';
import { firebaseRef, errorAlert, successAlert } from '../util/helperFunctions';
import { Title } from 'bloomer/lib/elements/Title';
import Conditional from './Conditional';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Input } from 'bloomer/lib/elements/Form/Input';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Help } from 'bloomer/lib/elements/Form/Help';
import { Button } from 'bloomer/lib/elements/Button';

class CreateAccount extends React.Component {
  state = {
    userEmail: '',
    userPassword: '',
    confirmPassword: '',
    errorMessage: '',
  };

  handleChange = (e: SyntheticEvent) => {
    const target = e.target as HTMLInputElement;

    if (target.type === 'checkbox') {
      this.setState({
        [target.name]: target.checked,
      });
    } else {
      this.setState({
        [target.name]: target.value,
      });
    }
  };
  parseFirebaseError(errorCode: string) {
    let errorMessage = 'Something went wrong.';
    switch (errorCode) {
      case 'auth/email-already-in-use':
        // Thrown if there already exists an account with the given email address.
        errorMessage =
          'Hey, that email is already in use. Did you forget your password?';
        break;
      case 'auth/invalid-email':
        // Thrown if the email address is not valid.
        errorMessage = 'Sorry, that isn\'t a valid email address.';
        break;
      case 'auth/operation-not-allowed':
        // Thrown if email/password accounts are not enabled. Enable email/password accounts in the Firebase Console, under the Auth tab.
        errorMessage = 'Configuration error. Contact your developer.';
        break;
      case 'auth/weak-password':
        // Thrown if the password is not strong enough.
        errorMessage = 'That\'s not a strong enough password.';
        break;
      default:
        errorMessage = 'Something went wrong.';
        break;
    }
    return errorMessage;
  }

  createAccount = async (email: string, password: string) => {
    try {
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      const timestamp = moment().valueOf();
      const userRef = firebaseRef(`/users`);
      const userDefaults = {
        email,
        admin: 'disabled',
        dateCreated: timestamp,
      };
      await userRef.push(userDefaults);
      await successAlert(
        'Account Created!',
        'Your account has been created successfully!'
      );
      window.location.href = '/';
    } catch (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = this.parseFirebaseError(errorCode);
      errorAlert(undefined, errorMessage);
      this.setState({ errorMessage });
    }
  };
  submitForm = (e: SyntheticEvent) => {
    e.preventDefault();
    if (this.state.userPassword === this.state.confirmPassword) {
      this.createAccount(this.state.userEmail, this.state.userPassword);
    } else {
      errorAlert(undefined, 'Your passwords do not match');
    }
  };
  render() {
    const { errorMessage, userEmail, userPassword } = this.state;
    return (
      <>
        <Title isSize={4} tag="h2">
          Create New Account:
        </Title>
        <form onSubmit={this.submitForm}>
          <Conditional check={errorMessage.length > 0}>
            <Help isColor="danger">ERROR: {errorMessage}</Help>
          </Conditional>

          <Field>
            <Label htmlFor="userEmail">Email Address:</Label>
            <Control>
              <Input
                id="userEmail"
                name="userEmail"
                type="email"
                value={userEmail}
                required={true}
                onChange={this.handleChange}
              />
            </Control>
          </Field>

          <Field>
            <Label htmlFor="userPassword">Password:</Label>
            <Control>
              <Input
                id="userPassword"
                name="userPassword"
                type="password"
                value={userPassword}
                required={true}
                onChange={this.handleChange}
              />
            </Control>
          </Field>

          <Field>
            <Label htmlFor="confirmPassword">Confirm Password:</Label>
            <Control>
              <Input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                value={this.state.confirmPassword}
                required={true}
                onChange={this.handleChange}
              />
            </Control>
          </Field>
          <Field isGrouped="centered">
            <Button type="submit" isColor="primary">
              Create Account
            </Button>
          </Field>
        </form>
      </>
    );
  }
}

export default CreateAccount;
